import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaTrash, FaThumbsUp } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Notices() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal,   setModal]   = useState(false);
  const [form, setForm] = useState({ title: '', body: '', target_roles: 'all', start_date: '', end_date: '', is_pinned: false, send_email: false });

  const load = () => adminApi.getNotices().then(r => setNotices(r.data.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const res = await adminApi.addNotice({ ...form, is_pinned: form.is_pinned ? 1 : 0, send_email: form.send_email ? 1 : 0 });
      const emailsSent = res.data.data?.emails_sent || 0;
      toast.success(`Notice posted!${form.send_email && emailsSent > 0 ? ` Email sent to ${emailsSent} recipient(s).` : ''}`);
      setModal(false); load();
    }
    catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this notice?')) return;
    try { await adminApi.deleteNotice(id); toast.success('Deleted'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div><h2>Notice Board</h2><p>Post announcements for teachers, learners, and parents</p></div>
        <button className="sms-btn sms-btn-primary" onClick={() => { setForm({ title:'',body:'',target_roles:'all',start_date:'',end_date:'',is_pinned:false,send_email:false }); setModal(true); }}>
          <FaPlus size={13} /> Post Notice
        </button>
      </div>

      {loading ? <Spinner /> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {notices.map(n => {
            const isClass = n.scope === 'class' || n.scope === 'parent';
            const borderColor = n.is_pinned ? '#f59e0b' : isClass ? '#10b981' : '#0d6efd';
            return (
              <div key={n.notice_id} className="sms-card" style={{ borderLeft: `4px solid ${borderColor}`, background: isClass ? '#f0fdf4' : '#fff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                      {n.is_pinned && <span style={{ fontSize: '0.72rem', background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: 12, fontWeight: 700 }}>📌 PINNED</span>}
                      <span style={{ fontSize: '0.72rem', background: isClass ? '#10b98118' : '#0d6efd18', color: isClass ? '#10b981' : '#0d6efd', padding: '2px 8px', borderRadius: 12, fontWeight: 600 }}>
                        {isClass ? '🏫 Class Notice' : '🏟️ School-wide'}
                      </span>
                      <span style={{ fontSize: '0.72rem', color: '#9ca3af' }}>For: {n.target_roles}</span>
                      {n.grade_number && <span style={{ fontSize: '0.72rem', background: '#eff6ff', color: '#0d6efd', padding: '2px 8px', borderRadius: 12, fontWeight: 600 }}>Grade {n.grade_number}</span>}
                    </div>
                    <h5 style={{ fontWeight: 600, margin: '0 0 8px' }}>{n.title}</h5>
                    <p style={{ color: '#4b5563', fontSize: '0.9rem', marginBottom: 10, lineHeight: 1.6 }}>{n.body}</p>
                    <div style={{ display: 'flex', gap: 16, fontSize: '0.78rem', color: '#9ca3af', flexWrap: 'wrap' }}>
                      <span>By: {n.author_name}</span>
                      {n.start_date && <span>{n.start_date} → {n.end_date || 'ongoing'}</span>}
                      <span>{new Date(n.created_at).toLocaleDateString()}</span>
                    </div>
                  </div>
                  <button className="sms-btn sms-btn-danger sms-btn-sm" style={{ marginLeft: 16 }} onClick={() => handleDelete(n.notice_id)}><FaTrash size={12} /></button>
                </div>
              </div>
            );
          })}
          {notices.length === 0 && <div className="sms-card" style={{ textAlign: 'center', color: '#9ca3af', padding: '60px 0' }}>No notices posted yet</div>}
        </div>
      )}

      <Modal show={modal} onClose={() => setModal(false)} title="Post Notice">
        <form onSubmit={handleSave}>
          <div style={{ marginBottom: 14 }}>
            <label className="sms-label">Title <span style={{ color:'#ef4444' }}>*</span></label>
            <input className="sms-input" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} required />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label className="sms-label">Message <span style={{ color:'#ef4444' }}>*</span></label>
            <textarea className="sms-input" rows={4} value={form.body} onChange={e => setForm({ ...form, body: e.target.value })} required style={{ resize: 'vertical' }} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <div>
              <label className="sms-label">Target Audience</label>
              <select className="sms-input" value={form.target_roles} onChange={e => setForm({ ...form, target_roles: e.target.value })}>
                <option value="all">Everyone</option>
                <option value="teacher">Teachers Only</option>
                <option value="learner">Learners Only</option>
                <option value="parent">Parents Only</option>
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 22 }}>
              <input type="checkbox" id="pinned" checked={form.is_pinned} onChange={e => setForm({ ...form, is_pinned: e.target.checked })} />
              <label htmlFor="pinned" style={{ cursor: 'pointer' }}><FaThumbsUp size={13} /> Pin this notice</label>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 20 }}>
            <div>
              <label className="sms-label">Start Date</label>
              <input className="sms-input" type="date" value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} />
            </div>
            <div>
              <label className="sms-label">End Date</label>
              <input className="sms-input" type="date" value={form.end_date} onChange={e => setForm({ ...form, end_date: e.target.value })} />
            </div>
          </div>

          {/* Email notification toggle */}
          <div style={{ background: form.send_email ? '#eff6ff' : '#f9fafb', border: `1px solid ${form.send_email ? '#bfdbfe' : '#e5e7eb'}`, borderRadius: 10, padding: '12px 16px', marginBottom: 20, cursor: 'pointer', transition: 'all 0.15s' }}
            onClick={() => setForm({ ...form, send_email: !form.send_email })}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <input type="checkbox" checked={form.send_email} onChange={() => {}} style={{ width: 16, height: 16, accentColor: '#0d6efd' }} />
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.88rem', color: form.send_email ? '#1d4ed8' : '#374151' }}>
                  📧 Also send email notification
                </div>
                <div style={{ fontSize: '0.78rem', color: '#6b7280', marginTop: 2 }}>
                  {form.target_roles === 'all' && 'Email will be sent to learners, parents and teachers'}
                  {form.target_roles === 'learner' && 'Email will be sent to learners who have an email address'}
                  {form.target_roles === 'parent' && 'Email will be sent to all linked parents'}
                  {form.target_roles === 'teacher' && 'Email will be sent to all teachers'}
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: 10 }}>
            <button type="submit" className="sms-btn sms-btn-primary">Post Notice</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={() => setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
